import { atom, useAtom } from "jotai";
import dataService from "../../helpers/dataService";

const insuranceCompaniesAtom = atom([]);

const useInsuranceCompanies = () => {
  const [insuranceCompanies, setInsuranceCompanies] = useAtom(insuranceCompaniesAtom);

  const onGetInsuranceCompanies = () => {
    dataService.get(`constants/compagnies-assurance`, (data) => {
      setInsuranceCompanies(
        (data || []).map(({ id, nom }) => ({ id, name: nom })),
      );
    });
  };

  return {
    insuranceCompanies,
    onGetInsuranceCompanies,
  };
};

export default useInsuranceCompanies;
